import React, { useEffect, useState } from 'react';
import { Platform, StyleSheet, Dimensions, View, StatusBar, TouchableOpacity, Text } from 'react-native';
import { isTablet } from 'react-native-device-info';
import Modal from 'react-native-modal';
import colors from '../resources/colors';
import * as NavigationBar from 'expo-navigation-bar';
import AuthenticationController from '../controllers/AuthenticationController';
import { EventRegister } from 'react-native-event-listeners';

const NoAccessModal = ({ }) => {
  const [visible, setVisible] = useState(true);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  useEffect(() => {
    const changeNavigationBar = async () => {
      if (Platform.OS !== 'android') {
        return;
      }

      if (visible) {
        await NavigationBar.setBackgroundColorAsync('#7D7F80');
      } else {
        await NavigationBar.setBackgroundColorAsync(colors.accentWhite);
      }
    };

    changeNavigationBar();
  }, [visible]);

  const goBack = async () => {
    // setVisible(false);
    EventRegister.emit('no-access/go-back');
  };

  const closeModal = () => {
    setVisible(false);
  };


  const openSubscriptions = async () => {
    EventRegister.emit('subscriptions/open-accounts');
    setVisible(false);
  };

  return (
    <Modal
      isVisible={visible}
      animationIn="fadeIn"
      animationOut="fadeOut"
      onBackdropPress={() => console.log()}
      onBackButtonPress={() => goBack()}
      hasBackdrop={true}
      // coverScreen={false}
      transparent={true}
      statusBarTranslucent={true}
      deviceHeight={Dimensions.get('screen').height}
      backdropTransitionInTiming={200}
      backdropTransitionOutTiming={0}
      backdropOpacity={0.6}
      backdropColor={colors.grey90}
      style={[styles.webModal, styles.webHeight]}>
      <StatusBar translucent backgroundColor="transparent" />
      <View
        style={{
          backgroundColor: colors.accentWhite,
          borderRadius: 10,
          width: Dimensions.get('window').width - 64,
          maxWidth: 350,
          paddingTop: 24,
          paddingBottom: 22,
          paddingHorizontal: 15,
          justifyContent: 'space-between',
        }}>
        <View>
          <Text
            allowFontScaling={false}
            style={{
              fontFamily: 'FiraSans-SemiBold',
              fontSize: 22,
              fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
              fontStyle: 'normal',
              lineHeight: 30,
              letterSpacing: 0.1,
              color: colors.defaultText,
              marginBottom: 8,
            }}>
            {'It looks like you don‘t have full offline access'}
          </Text>
          <Text
            allowFontScaling={false}
            style={[styles.text, { marginBottom: 8 }]}>
            {'You either do not have a valid subscription, or your subscription is online only, which means your are unable to view this day when not connected to the internet. Please restore your internet connection to view this day.'}
          </Text>
          <Text
            allowFontScaling={false}
            style={[styles.text, { marginBottom: 20 }]}>
            {'Alternatively, you can purchase a full offline subscription. If you have purchase a full offline subscription, restore your purchase in the subscription options.'}
          </Text>
        </View>
        <View>
          <TouchableOpacity
            style={{
              width: '100%',
              height: 50,
              borderRadius: 8,
              backgroundColor: colors.primary,
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onPress={() => goBack()}>
            <Text
              allowFontScaling={false}
              style={{
                fontFamily: 'FiraSans-SemiBold',
                fontSize: 17,
                fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
                fontStyle: 'normal',
                lineHeight: 24,
                letterSpacing: 0.1,
                textAlign: 'center',
                color: colors.accentWhite,
              }}>
              {'Go back'}
            </Text>
          </TouchableOpacity>
          <View
            style={{
              marginVertical: 8,
              flexDirection: 'row',
              alignItems: 'center',
            }}>
            <View
              style={{
                height: 2,
                flex: 1,
                backgroundColor: colors.grey40,
              }}
            />
            <Text
              allowFontScaling={false}
              style={{
                fontFamily: 'FiraSans-Regular',
                fontSize: 17,
                fontWeight: 'normal',
                fontStyle: 'normal',
                lineHeight: 26,
                letterSpacing: 0,
                textAlign: 'center',
                color: colors.defaultText,
                marginHorizontal: 8,
              }}>
              {'or'}
            </Text>
            <View
              style={{
                height: 2,
                flex: 1,
                backgroundColor: colors.grey40,
              }}
            />
          </View>
          <TouchableOpacity
            style={{
              width: '100%',
              height: 50,
              borderRadius: 8,
              backgroundColor: colors.primary,
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onPress={() => openSubscriptions()}>
            <Text
              allowFontScaling={false}
              style={{
                fontFamily: 'FiraSans-SemiBold',
                fontSize: 17,
                fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
                fontStyle: 'normal',
                lineHeight: 24,
                letterSpacing: 0.1,
                textAlign: 'center',
                color: colors.accentWhite,
              }}>
              {'View subscription options'}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  webModal: {
    alignItems: undefined,
    justifyContent: 'center',
    height: null,
    overflow: 'hidden',
    borderRadius: 0,
    borderColor: 'rgba(0, 0, 0, 0.1)',
    alignSelf: 'center',
    top: 0,
    margin: 0,
  },
  webContainer: {
    height: '100%',
    backgroundColor: colors.accentWhite,
  },
  webHeight: {
    height: Dimensions.get('window').height,
  },
  text: {
    fontFamily: 'FiraSans-Regular',
    fontSize: 17,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: 26,
    letterSpacing: 0,
    color: colors.defaultText,
  },
})

export default NoAccessModal;
